import { render, staticRenderFns } from "./ContractPublisherShares.vue?vue&type=template&id=a1859312"
import script from "./ContractPublisherShares.vue?vue&type=script&lang=js"
export * from "./ContractPublisherShares.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports